import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// Customizing your theme — 4 frames: preset picker -> color tokens -> font
// selects -> live preview.
function TCPresets(): JSX.Element {
  return (
    <SimShell step={1} total={4} title="Preset cards">
      <div className="grid grid-cols-2 gap-1.5 text-[11px]">
        {[
          ['Editorial Warm', true],
          ['Clinical Clean', false],
          ['Modern Minimal', false],
          ['Bold Contrast', false],
        ].map(([name, active]) => (
          <div
            key={String(name)}
            className={
              'rounded border px-2 py-1.5 ' +
              (active
                ? 'border-accent/40 bg-accent/10 text-accent'
                : 'border-dash-border bg-dash-surface text-dash-secondary')
            }
          >
            {name}
          </div>
        ))}
      </div>
    </SimShell>
  );
}

function TCTokens(): JSX.Element {
  return (
    <SimShell step={2} total={4} title="Colour tokens">
      <div className="grid grid-cols-3 gap-1.5 text-[10px]">
        {[
          ['Accent', 'border-accent/60 bg-accent/20'],
          ['Surface', 'border-dash-border bg-dash-surface'],
          ['Warning', 'border-warning/60 bg-warning/20'],
          ['Text', 'border-dash-border bg-dash-primary/20'],
          ['Border', 'border-dash-border bg-dash-bg'],
          ['Success', 'border-success/60 bg-success/20'],
        ].map(([label, cls]) => (
          <div
            key={label}
            className={'rounded border px-2 py-2 text-dash-secondary ' + cls}
          >
            {label}
          </div>
        ))}
      </div>
    </SimShell>
  );
}

function TCFonts(): JSX.Element {
  return (
    <SimShell step={3} total={4} title="Font families">
      <div className="space-y-1 text-xs">
        {[
          ['Serif', 'Source Serif Pro'],
          ['Sans', 'Inter'],
          ['Mono', 'JetBrains Mono'],
        ].map(([role, family]) => (
          <div
            key={role}
            className="flex items-center justify-between rounded border border-dash-border bg-dash-surface px-2 py-1"
          >
            <span className="text-dash-muted font-mono text-[10px] uppercase">{role}</span>
            <span className="text-dash-primary">{family}</span>
          </div>
        ))}
      </div>
    </SimShell>
  );
}

function TCPreview(): JSX.Element {
  return (
    <SimShell step={4} total={4} title="Live preview">
      <div className="rounded border border-dash-border bg-dash-surface p-2">
        <div className="h-1 w-full rounded bg-accent/60 mb-2" />
        <div className="text-dash-primary text-sm">Your article, themed</div>
        <div className="text-[11px] text-dash-secondary">
          The preview updates 300ms after every edit.
        </div>
      </div>
      <div className="mt-1.5 text-[10px] font-mono text-warning">
        invalid hex → preview freezes on the last good state
      </div>
    </SimShell>
  );
}

export function ThemeCustomizationSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <TCPresets />, label: 'Start from a preset', duration: D },
        { frame: <TCTokens />, label: 'Tune sixteen colour tokens', duration: D },
        { frame: <TCFonts />, label: 'Pick serif, sans, and mono', duration: D },
        { frame: <TCPreview />, label: 'Watch the live preview', duration: D },
      ]}
    />
  );
}
